import React, { useEffect, useState } from "react";
import API from "../api";
import "./LeadDashboard.css";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
export default function LeadDashboard() {
  const navigate = useNavigate();
  const [leaves, setLeaves] = useState([]);
  const [day, setDay] = useState("");
  // const [day, setDay] = useState(() =>
  //     new Date().toISOString().split("T")[0]   // Default: today
  // );

  const [page, setPage] = useState(1);
  const [month, setMonth] = useState("");
  const [username, setUsername] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [leave_status, setLeaveStatus] = useState("");

  const isDaySelected = !!day;
  const isMonthSelected = !!month;
  const isRangeSelected = !!fromDate || !!toDate;


  const limit = 10;

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [viewReason, setViewReason] = useState("");
  const [isViewOnly, setIsViewOnly] = useState(false);
  useEffect(() => {
    fetchLeaves();
  }, [day, month, username, fromDate, toDate, leave_status, page]);
  // If day selected → reset others
  useEffect(() => {
    if (day) {
      setMonth("");
      setFromDate("");
      setToDate("");
    }
  }, [day]);


  // If month selected → reset day
  useEffect(() => {
    if (month) {
      setDay("");
    }
  }, [month]);


  // If range selected → reset day & month
  useEffect(() => {
    if (fromDate || toDate) {
      setDay("");
      setMonth("");
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    setPage(1);
  }, [day, month, username, fromDate, toDate, leave_status]);

  const fetchLeaves = async () => {
    try {
      let params = {};

      if (day) params.day = day;
      if (month) params.month = month;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      if (username) params.username = username;
      if (leave_status) params.leave_status = leave_status;
      const token = localStorage.getItem("token");

      const res = await API.get("/teamlead/leave", {
        params,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      setLeaves(res.data);
      console.log("Fetched Leaves:", res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const approveLeave = async (leaveId) => {

    const confirmApprove = window.confirm(
      "Are you sure you want to approve this leave?"
    );

    if (!confirmApprove) return; // if Cancel clicked, stop here

    const token = localStorage.getItem("token");

    await API.put(`/teamlead/approve/${leaveId}`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });

    fetchLeaves();
  };

  const rejectLeave = async (leaveId) => {
    const reason = prompt("Enter reject reason");
    if (!reason) return;

    const token = localStorage.getItem("token");

    await API.put(`/teamlead/reject/${leaveId}`, {
      lead_reject_reason: reason
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    fetchLeaves();
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  // CSV DOWNLOAD
  const downloadCSV = async () => {
    try {
      const params = { page: 1, limit: 10000 }; // fetch all

      if (day) params.day = day;
      if (month) params.month = month;
      if (username) params.username = username;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      if (leave_status) params.leave_status = leave_status;

      const res = await API.get("/teamlead/leave", { params });

      if (!res.data || res.data.length === 0) {
        alert("No data to download");
        return;
      }

      const ws = XLSX.utils.json_to_sheet(res.data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Leave Attendance");

      XLSX.writeFile(wb, "leave_attendance_report.xlsx");
    } catch (err) {
      console.error(err);
      alert("Failed to download Excel");
    }
  };

  return (
    // <div className="lead-dashboard">

    //   <div className="dashboard-header">
    //     <h2>Leave Approval - Team Lead</h2>
    //   </div>

    //   <div className="dashboard-card">

    //     <table className="styled-table">
    //       <thead>
    //         <tr>
    //           <th>Employee</th>
    //           <th>From Date</th>
    //           <th>To Date</th>
    //           <th>Reason</th>
    //           <th>Action</th>
    //         </tr>
    //       </thead>

    //       <tbody>
    //         {leaves.length === 0 ? (
    //           <tr>
    //             <td colSpan="5" className="no-data">
    //               No Pending Leave Requests
    //             </td>
    //           </tr>
    //         ) : (
    //           leaves.map((leave) => (
    //             <tr key={leave.id}>
    //               <td>{leave.employee_name}</td>
    //               <td>{leave.date}</td>
    //               <td>{leave.todate}</td>
    //               <td>{leave.reason}</td>
    //               <td>
    //                 <button
    //                   className="btn approve-btn"
    //                   onClick={() => approveLeave(leave.id)}
    //                 >
    //                   Approve
    //                 </button>

    //                 <button
    //                   className="btn reject-btn"
    //                   onClick={() => rejectLeave(leave.id)}
    //                 >
    //                   Reject
    //                 </button>
    //               </td>
    //             </tr>
    //           ))
    //         )}
    //       </tbody>
    //     </table>

    //   </div>
    // </div>

    <div className="dashboard-wrapper">
      <div className={`sidebar-container ${sidebarOpen ? "open" : "closed"}`}>
        <Sidebar />
      </div>

      <div className={`page-area ${sidebarOpen ? "" : "full"}`}>
        <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="main-content">
          <div className="container-fluid py-4">
            {/* <div className="top-navbar">
                                        <div className="nav-left">
                                            <img src="/Dashboard-Red-64.png" className="dash-icon"/>
                                            <span>Attendance Dashboard</span>
                                        </div>
            
                                        <div className="nav-right">
                                            <span className="admin">Admin</span>
                                        </div>
                                    </div> */}
            <div className="dashboard-title">
              <img
                src="/Dashboard-Red-64.png"
                alt="dashboard"
                className="dashboard-icon"
              />
              <span>Dashboard</span>
            </div>

            {/* HEADER */}
            <div className="search-card">
              <h2>Leave Attendance</h2>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  placeholder="Search Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <span style={{
                  position: "absolute",
                  right: 18,
                  top: "50%",
                  transform: "translateY(-50%)"
                }}>🔍</span>
              </div>
            </div>
            {/* FILTERS */}
            <div className="filter-row">

              <div className="filter-group">
                <label className="filter-label">Select Day</label>
                <input
                  type="date"
                  value={day}
                  disabled={isMonthSelected || isRangeSelected}
                  onChange={(e) => setDay(e.target.value)}
                  className="filter-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Select Month</label>
                <input
                  type="month"
                  value={month}
                  disabled={isDaySelected || isRangeSelected}
                  onChange={(e) => setMonth(e.target.value)}
                  className="filter-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">From Date</label>
                <input
                  type="date"
                  value={fromDate}
                  disabled={isDaySelected}
                  max={toDate || undefined}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="filter-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">To Date</label>
                <input
                  type="date"
                  value={toDate}
                  disabled={isDaySelected}
                  min={fromDate || undefined}
                  onChange={(e) => setToDate(e.target.value)}
                  className="filter-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Status</label>
                <select
                  value={leave_status}
                  onChange={(e) => setLeaveStatus(e.target.value)}
                  className="filter-input"
                >
                  <option value="">All</option>
                  {/* <option value="in">In</option>
                                            <option value="out">Out</option>
                                            <option value="half-day">Half Day</option> */}
                  <option value="leave">Leave</option>
                </select>
              </div>

              <button className="download-btn" onClick={downloadCSV}>
                ⬇ Download CSV
              </button>
            </div>
            {/* TABLE */}
            <div className="table-card">
              <table>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Team_Lead</th>
                    <th>Date</th>
                    <th>To_Date</th>
                    <th>Subject</th>
                    <th>Reason</th>
                    <th>Lead_Approval</th>
                    {/* <th>Leave Type</th> */}
                    <th>Action</th>
                    <th>Rejected Reason</th>
                  </tr>
                </thead>

                <tbody>
                  {leaves.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="no-data">
                        No Pending Leave Requests
                      </td>
                    </tr>
                  ) : (
                    leaves.map((leave) => (
                      <tr key={leave.id}>
                        <td>{leave.user_name}</td>
                        <td>{leave.Team_Lead}</td>
                        <td>{leave.date}</td>
                        <td>{leave.todate}</td>
                        <td>{leave.subject}</td>
                        <td>{leave.reason}</td>
                        <td>
                          <span className={
                            leave.lead_status === "approved"
                              ? "approved"
                              : leave.lead_status === "rejected"
                                ? "rejected"
                                : "pending"
                          }>
                            {leave.lead_status}
                          </span>
                        </td>

                        <td>
                          <button
                            className="btn approve-btn"
                            onClick={() => approveLeave(leave.id)}
                          >
                            Approve
                          </button>

                          <button
                            className="btn reject-btn"
                            onClick={() => rejectLeave(leave.id)}
                          >
                            Reject
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

            </div>

            {/* PAGINATION */}
            <div className="pagination-section">
              <span>Showing 1 of 5 entries</span>
              <div className="pagination-controls">
                <button>«</button>
                <button className="active">1</button>
                <button>2</button>
                <button>»</button>
              </div>
            </div>

            {/* REJECT MODAL */}
            {/* Reject Modal */}
            {showRejectModal && (
              <div className="modal-overlay">
                <div className="modal-box">
                  <h4>
                    {isViewOnly ? "Rejected Reason" : "Reject Leave Reason"}
                  </h4>

                  <textarea
                    value={isViewOnly ? viewReason : rejectReason}
                    onChange={e => setRejectReason(e.target.value)}
                    placeholder="Enter reason"
                    readOnly={isViewOnly}
                  />

                  <div className="modal-actions">
                    {!isViewOnly && (
                      <button className="approve-btn" onClick={rejectLeave}>
                        Submit
                      </button>
                    )}

                    <button
                      className="reject-btn"
                      onClick={() => {
                        setShowRejectModal(false);
                        setRejectReason("");
                        setViewReason("");
                        setIsViewOnly(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}


          </div>
        </div>
      </div>
    </div>
  );
}